import React from 'react';
import LogsViewer from '../../../components/shared/LogsViewer';

interface PipeLogsViewerProps {
  pipeId: string;
  pipeName?: string;
  state?: any;
  actions?: any;
}

const PipeLogsViewer: React.FC<PipeLogsViewerProps> = ({ pipeId, pipeName }) => {
  return (
    <LogsViewer
      filterPrefix={`[PIPE:${pipeId}]`}
      title="Pipe Logs"
      subtitle={pipeName}
    />
  );
};

export default PipeLogsViewer;

